import groupby from 'lodash.groupby';
import { isStringDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

export default function createSelectClientOptions(
  clientsList,
  onlyClientsNames = false
) {
  return Optional(clientsList)
    .map(clientsList => mapClients(clientsList, onlyClientsNames))
    .or([]);
}

function mapClients(clientsList, onlyClientsNames = false) {
  const groupedClients = groupby(clientsList, client =>
    Optional(client.partner)
      .map(client => client.name)
      .or('')
  );

  return Object.keys(groupedClients)
    .sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1))
    .map(partner => {
      const mappedClients = groupedClients[partner].map(client => {
        return {
          value: Number(client.id),
          label: onlyClientsNames ? client.name : createClientOptionText(client)
        };
      });

      return {
        label: partner !== '' ? partner : 'IPVision',
        options: mappedClients
      };
    });
}

function createClientOptionText(client) {
  let notes = '';

  if (isStringDefined(client.notes)) {
    notes =
      client.notes.length > 40
        ? `${client.notes.slice(0, 40)}...`
        : client.notes;
  }

  return {
    name: `${client.name} 
    ${mapClientTextSection(client.display_name)}
    ${mapClientTextSection(client.connect30_domain)}`,
    notes,
    platform: Optional(client.platform).or('')
  };
}

function mapClientTextSection(value) {
  return isStringDefined(value) ? `- ${value}` : '';
}
